import { render, staticRenderFns } from "./AssetCurrentReport.vue?vue&type=template&id=8e529d42&"
import script from "./AssetCurrentReport.vue?vue&type=script&lang=ts&"
export * from "./AssetCurrentReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports